

function Circle(){
    return (<div className={"circle"}>
    </div>)
} export default Circle;